export default __webpack_public_path__ + "static/media/pdf.344c1228.svg";